var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProcessor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_280_12091)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 13,
    width: 48,
    height: 48,
    rx: 9.6,
    fill: "#610ECD",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 13,
    width: 48,
    height: 48,
    rx: 9.6,
    fill: "url(#paint0_linear_280_12091)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.625,
    y: 12.625,
    width: 48.75,
    height: 48.75,
    rx: 9.975,
    stroke: "#D9CDFF",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2577 28.1846L52.2598 28.1854C52.657 28.3453 53.0366 28.6761 53.3183 29.0952C53.6 29.5143 53.7623 29.9896 53.7623 30.4125V35.9C53.7623 41.8377 49.4434 47.4191 43.5378 49.051C43.1904 49.1455 42.8092 49.1455 42.4618 49.051C36.5562 47.4191 32.2373 41.8377 32.2373 35.9V30.4125C32.2373 29.9895 32.3996 29.514 32.6803 29.0945C32.9609 28.6749 33.3378 28.3443 33.7289 28.1848L33.7294 28.1846L40.6915 25.3347C40.6916 25.3347 40.6917 25.3347 40.6918 25.3346C42.1633 24.7343 43.8238 24.7343 45.2953 25.3346C45.2954 25.3347 45.2955 25.3347 45.2956 25.3347L52.2577 28.1846ZM44.3123 41.375V38.3506C45.5871 37.8334 46.4998 36.5983 46.4998 35.125C46.4998 33.1929 44.9319 31.625 42.9998 31.625C41.0677 31.625 39.4998 33.1929 39.4998 35.125C39.4998 36.5859 40.4118 37.8317 41.6873 38.3505V41.375C41.6873 42.0946 42.2802 42.6875 42.9998 42.6875C43.7194 42.6875 44.3123 42.0946 44.3123 41.375Z",
    fill: "#EBE4FF",
    stroke: "#FBFAFF",
    strokeWidth: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_280_12091",
    x: 0.25,
    y: 0.25,
    width: 85.5,
    height: 85.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.37398 0 0 0 0 0.193943 0 0 0 0 0.607543 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_280_12091"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_280_12091",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_280_12091",
    x1: 19,
    y1: 13,
    x2: 67,
    y2: 61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#DB6704",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DB6704",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessor);
export default __webpack_public_path__ + "static/media/processor.db51e511897061f7de021d4eb4b24328.svg";
export { ForwardRef as ReactComponent };